import $ from 'jquery';
import 'bootstrap/js/dist/popover';
$(function() {
  return $('[data-toggle="popover"]').popover();
});
